(() => {
 const dataFor = options => JSON.parse(options.querySelector('[data-sd-purchase-variants]').textContent);
 const showPrice = (options, html) => {
  const root = options.closest('product-info');
  const regular = root?.querySelector('[id^="price-"] .price__regular .price-item--regular');
  if (regular) regular.innerHTML = html;
 };
 const updateSelection = options => {
  const select = options.querySelector('[data-sd-selling-plan]');
  const subscribed = options.querySelector('[data-sd-purchase-mode]:checked')?.value === 'subscription';
  select.disabled = !subscribed || !select.options.length;
  select.required = !select.disabled;
  options.querySelector('.sd-delivery-label').hidden = !subscribed;
  options.querySelector('.sd-recurring-note').hidden = !subscribed;
  const variant = dataFor(options)[options.dataset.selectedVariant];
  const plan = variant?.plans.find(plan => String(plan.id) === select.value);
  options.querySelector('[data-sd-subscription-price]').innerHTML = plan?.price || '';
  if (variant) showPrice(options, subscribed && plan ? plan.price : variant.price);
 };
 const updateVariant = (options, id) => {
  const variant = dataFor(options)[id];
  if (!variant) return;
  options.dataset.selectedVariant = id;
  options.querySelector('[data-sd-once-price]').innerHTML = variant.price;
  const select = options.querySelector('[data-sd-selling-plan]');
  select.replaceChildren(...variant.plans.map(plan => {
   const option = document.createElement('option'); option.value = plan.id; option.textContent = plan.name; return option;
  }));
  options.querySelector('[data-sd-subscription-choice]').hidden = !variant.plans.length;
  options.querySelector('[data-sd-purchase-mode][value="once"]').checked = true;
  updateSelection(options);
 };
 const connect = () => document.querySelectorAll('[data-sd-purchase-options]').forEach(options => {
  if (options.dataset.connected) return;
  options.dataset.connected = 'true';
  updateVariant(options, options.dataset.selectedVariant);
 });
 document.addEventListener('change', event => {
  if (event.target.matches('[data-sd-purchase-mode], [data-sd-selling-plan]')) updateSelection(event.target.closest('[data-sd-purchase-options]'));
  if (event.target.matches('input[name="id"]')) event.target.closest('product-info')?.querySelectorAll('[data-sd-purchase-options]').forEach(options => updateVariant(options, event.target.value));
 });
 connect();
 document.addEventListener('shopify:section:load', connect);
})();
